import { useStore, useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { selectors } from '~/store/state-selectors';
const EMPTY_STATS = [];
export const useHistoricAgreementStats = function useHistoricAgreementStats() {
    let { refreshOnHookMount = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const businessId = useStore(selectors.user.businessId);
    const { data, isLoading, isFetching, refresh, error } = useQueryState({
        queryKey: [
            QueryKeys.HistoricAgreementStats,
            businessId
        ],
        queryFn: ()=>api.report.getHistoricAgreementStats(businessId),
        enabled: !!businessId,
        refreshOnHookMount
    });
    return {
        historicAgreementStats: data !== null && data !== void 0 ? data : EMPTY_STATS,
        isLoading,
        isFetching,
        refresh,
        error
    };
};
